import { makeAutoObservable } from 'mobx'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { RinglessMessageFieldStore } from 'widgets/MessageFormFields/RinglessMessageField'

export class CampaignRinglessStore {
  ringlessMessageFieldStore
  constructor(private _entities: IEntitiesStore) {
    this.ringlessMessageFieldStore = new RinglessMessageFieldStore(this._entities)
    makeAutoObservable(this)
  }

  init: typeof this.ringlessMessageFieldStore.init = (...params) =>
    this.ringlessMessageFieldStore.init(...params)

  get ringlessMessageDataParams() {
    return this.ringlessMessageFieldStore.ringlessMessageDataParams
  }

  get error() {
    return this.ringlessMessageFieldStore.error
  }

  setError: typeof this.ringlessMessageFieldStore.setError = (...params) =>
    this.ringlessMessageFieldStore.setError(...params)

  checkValidate = () => {
    let validate = true
    if (!this.ringlessMessageDataParams.media_url.length) {
      validate = false
      this.setError('Your message is the key – please select an audio')
    }
    return validate
  }
}
